import { routesPublicNotLogin } from "../config/App-layout";

/**
 * 使用者是否可看見 menu 或進入該頁面
 * @param routeObj {Object}
 * @param role {String || Array} : "admin, approver" or ['admin', 'approver']
 * @returns {boolean}
 */
export const allowGetIn = (routeObj, role) => {
  if (!(routeObj && role)) {
    return routesPublicNotLogin.indexOf(routeObj.path) >= 0;
  }
  if (!(Array.isArray(role) || typeof role === "string")) return false;
  // 把 string role 轉成 array
  let roles = role;
  if (typeof role === "string") {
    roles = role.split(",");
  }
  let getIn = false;
  roles.forEach((r) => {
    if (routeObj.authority.indexOf(r.toLowerCase()) >= 0) getIn = true;
  });
  return getIn;
};
